var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoicemail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66536 13.3334L15.6654 13.3334M5.66536 13.3334C7.50631 13.3334 8.9987 11.841 8.9987 10C8.9987 8.15907 7.50631 6.66669 5.66536 6.66669C3.82442 6.66669 2.33203 8.15907 2.33203 10C2.33203 11.841 3.82442 13.3334 5.66536 13.3334ZM15.6654 13.3334C17.5063 13.3334 18.9987 11.841 18.9987 10C18.9987 8.15907 17.5063 6.66669 15.6654 6.66669C13.8244 6.66669 12.332 8.15907 12.332 10C12.332 11.841 13.8244 13.3334 15.6654 13.3334Z",
    stroke: "#1672BA",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoicemail);
export default __webpack_public_path__ + "static/media/voicemail.537aa537a015e894d2c55920d9d1b243.svg";
export { ForwardRef as ReactComponent };